<template>
    <div class="action-message">
        <simple-svg v-if="status === 'confirmed'" :src="CheckIcon" width="16" height="16"
            custom-class-name="icon-blue" />
        <simple-svg v-else-if="status === 'rejected'" :src="CloseMd" width="16" height="16"
            custom-class-name="icon-red" />
        <div v-else-if="status === 'pending'" class="spinner"></div>

        <div class="action-message__body">
            <p>{{ getActionName(msg.content.action) }}</p>

            <div v-if="msg.content.params && settingsStore.showToolsParams" class="params">
                <div v-for="(value, key) in msg.content.params" :key="key">
                    <span>{{ key }}: {{ value }}</span>
                </div>
            </div>

            <div v-if="showConfirmation" class="buttons-tool">
                <default-button text="Подтвердить" @click="$emit('confirm', msg.pendingId)" />
                <default-button text="Отклонить" @click="$emit('reject', msg.pendingId)" isSecondary />
            </div>

            <HoverBar :date="msg.created_at || msg.content.created_at" :message-id="msg.id" />
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import CheckIcon from '@/assets/icons/Check.svg';
import CloseMd from '@/assets/icons/Close_MD.svg';
import { getActionName } from '@/utils/actions';
import HoverBar from '../ui/HoverBar.vue';
import { useSettingsStore } from '@/store/SettingsStore';

const settingsStore = useSettingsStore();

defineProps({
    msg: { type: Object, required: true },
    status: { type: String, required: true },
    showConfirmation: { type: Boolean, default: false }
});

defineEmits(['confirm', 'reject']);
</script>

<style lang="scss" scoped>
.action-message {
    display: flex;
    align-items: start;
    gap: 10px;

    .icon, .icon-red {
        margin-top: 2px;
    }

    &:hover :deep(.hover-bar) {
        opacity: 1;
        pointer-events: auto;
    }
}

.action-message__body {
    span {
        color: var(--color-text-dark);
    }
}

.buttons-tool {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--color-border);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    flex-shrink: 0;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>
